import common from "../common";

export default class SaveData {

    constructor()
    {
        this.SAVE_NAME = "dhl_worldunited";

        this.template = {
            muted: false,
            videosPlayed: {}
        };
        this.data = {};

        this.init();
    }

    init()
    {
        for(var i in common.config.settings.videoLinks)
        {
            this.template.videosPlayed[i] = false;
        }
        this.load();
    }

    load()
    {   
        for(var i in this.template)
        {
            this.data[i] = this.template[i];
        }
        if(window.localStorage[this.SAVE_NAME])
        {
            var data = window.localStorage[this.SAVE_NAME];
            this.loadData(data);
        }
        this.save();
    }

    loadData(dataString)
    {
        var data = JSON.parse(dataString);

        this.data.muted = data.muted;
        for(var i in data.videosPlayed)
        {
            this.data.videosPlayed[i] = data.videosPlayed[i];
        }
    }

    save()
    {
        console.log(this.data);   
        window.localStorage[this.SAVE_NAME] = JSON.stringify(this.data);
    }

    clear()
    {
        this.data = {};
        for(var i in this.template)
        {
            this.data[i] = this.template[i];
        }
        this.save();
    }

    isVideoPlayed(videoId)
    {
        return this.data.videosPlayed[videoId];
    }

    markVideoAsPlayed(videoId)
    {
        this.data.videosPlayed[videoId] = true;
        this.save();
    }

    get muted()
    {
        return this.data.muted;
    }

    set muted(value)
    {
        this.data.muted = value;
        this.save();
    }
}